import { eventBus } from '@/core/eventBus'

// eslint-disable-next-line no-unused-vars
var vue, router, desktopClient

/**
 * Web给桌面端提供的接口
 */
export default class DesktopListener {
  constructor({ Vue, Router }) {
    vue = Vue
    router = Router
    desktopClient = Vue.prototype.$desktopClient
    this.sharedCloudDisk = new SharedCloudDiskHandler()
  }
}

/**
 * 共享云盘相关
 */
class SharedCloudDiskHandler {
  constructor() {
    this.file = new SharedCloudDiskFileHandler()
  }
}

/**
 * 共享云盘-文件相关
 */
class SharedCloudDiskFileHandler {
  /**
   * 更新文件
   * @param {Object} options 选项
   * @returns 
   */
  async renew(options) {
    // 0. 添加蒙层
    this.addMask()

    // 1. 参数检查
    if (!options) {
      console.error(`options must not empty`)
      return
    }
    if (!options.spaceId) {
      console.error(`missing space id`)
      return
    }

    const onFileListCompReady = async (comp) => await this.triggerRenewal(options, comp)
    try {
      // 2. 订阅事件：file-list-comp-ready
      eventBus.$on('file-list-comp-ready', onFileListCompReady)
      console.info('after adding event listener to event file-list-comp-ready: onFileListComponentReady')

      // 3. 路由到文件列表页
      const fileHomeRoute = `/${options.spaceId}/file`      
      console.info(`before pushing route: ${fileHomeRoute}`)
      await router.push(fileHomeRoute)
      console.info(`after pushing route: ${fileHomeRoute}`)
    } finally {
      // 4. 取消订阅事件：file-list-comp-ready
      eventBus.$off('file-list-comp-ready', onFileListCompReady)
      console.info('after removing event listener from event file-list-comp-ready: onFileListComponentReady')
    }
  }

  async triggerRenewal(options, comp) {
    console.info('on receiving event file-list-comp-ready from eventBus. current event listener: onFileListComponentReady')

    // 1. 获取vue组件内更新文件入口方法
    if (!comp) {
      console.error(`fail to find component`)
      return
    }
    if (!comp.onRenewal) {
      console.error(`fail to find method 'onRenewal'`)
      return
    }

    // 2. 触发vue组件内更新文件入口方法
    /**
     * 调用链上会唤起本地文件/目录选择对话框，由于浏览器安全策略的限制，不能通过代码去触发，因此需模拟用户交互动作进行触发，否则会遇到如下错误：
     *    element-ui.common.js?5c96:29633 File chooser dialog can only be shown with a user activation.
     */
    await this.mockUserGesture(async () => {
      console.info('on receiving user gesture')
      await comp.onRenewal({
        id: options.fileId * 1,
        fileType: options.fileType,
        name: options.fileName,
        suffix: options.fileSuffix,
        spaceId: options.spaceId
      }, 'renewal')
    })
  }

  async mockUserGesture(callback) {
    // 1. 创建辅助按钮
    const button = document.createElement('button')
    button.id = 'gjw-btn-for-mock-user-gesture'
    button.innerText = ''
    const onClick = () => {
      console.info('on receiving button click event')

      // 1. 移除辅助按钮
      document.body.removeChild(button)
      button.removeEventListener('click', onClick)
      console.info('after removing auxiliary button')

      // 2. 执行回调
      callback()
    }
    button.addEventListener('click', onClick)
    button.style.cssText = `
      position: fixed;
      top: 0px;
      left: 0px;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0);
      border:none;
    `
    // 将按钮设为铺满全屏，若模拟自动点击失效（偶尔），则若用户点击页面任意位置可继续

    // 2. 将辅助按钮添加到DOM
    document.body.appendChild(button)
    console.info('after adding auxiliary button')

    // 3. 模拟鼠标点击按钮
    await vue.nextTick()
    {
      // try1: 通过内嵌浏览器发送鼠标事件
      const rect = button.getBoundingClientRect()
      await desktopClient.PerformMouseClickInBrowser({
        x: Math.round(rect.x + rect.width / 2.0),
        y: Math.round(rect.y + rect.height / 2.0),
        mouseButtonType: 'Left',
        modifiers: null
      })
      // try2: 通过调用click
      // button.click()
      console.info('after performing click auxiliary button(later than click listener execution)')
    }
  }

  addMask() {
    // 1. 创建mask
    const mask = document.createElement('div')
    mask.style.cssText = `
      position: fixed;
      top: 0px;
      left: 0px;
      z-index: 2000;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.25);
    `

    // 2. 将mask添加到DOM
    document.body.appendChild(mask)
    console.info('after adding mask')
  }
}
